import type { Transaction } from "@rocicorp/zero";
import { userFacingError } from "./authorization";
import { type Schema, zql } from "./generatedDrizzleSchema";
import { tenantAdminUserGrants } from "./rbac/tenantAdmins";
import {
  assertNotLastAdmin,
  MIN_TENANT_ADMINS,
} from "./rbac/validation/adminGuard";

type Tx = Pick<Transaction<Schema>, "run">;

const LAST_ACTIVE_USER_ERROR = "Cannot deactivate the last active user";

export async function assertUserDeactivatable(
  tx: Tx,
  tenantId: string,
  userId: string
): Promise<void> {
  const activeUsers = await tx.run(
    zql.user.where("tenantId", tenantId).where("deactivated", false)
  );
  if (activeUsers.length <= MIN_TENANT_ADMINS) {
    throw userFacingError(LAST_ACTIVE_USER_ERROR);
  }

  const adminGrants = await tx.run(
    tenantAdminUserGrants(tenantId).where("userId", userId)
  );

  if (adminGrants.length > 0) {
    await assertNotLastAdmin(tx, tenantId, userId);
  }
}
